const COMMERCE_CHECKOUT_PATH_PATTERN =
  /^(?:\/[a-z]{2}-[A-Z]{2})?\/(?:stays|air)\//;

/** Fixed base URL for parsing relative checkout paths without touching window.location. */
const RELATIVE_PATH_VALIDATION_BASE = "https://nubank.local";

export function isCommerceCheckoutPath(pathname: string): boolean {
  return COMMERCE_CHECKOUT_PATH_PATTERN.test(pathname);
}

/**
 * Validates a stored OAuth return path before redirect.
 * Relative path only, no protocol-relative URLs, no traversal, stays/air allowlist.
 */
export function isSafeCommerceReturnPath(pathname: string): boolean {
  if (!pathname.startsWith("/") || pathname.startsWith("//")) {
    return false;
  }
  if (pathname.includes("..") || pathname.includes("\\")) {
    return false;
  }
  if (pathname.includes(":") || pathname.includes("@")) {
    return false;
  }

  let resolvedPath: string;
  try {
    resolvedPath = new URL(pathname, RELATIVE_PATH_VALIDATION_BASE).pathname;
  } catch {
    return false;
  }

  if (
    resolvedPath.includes("..") ||
    !resolvedPath.startsWith("/") ||
    resolvedPath.startsWith("//")
  ) {
    return false;
  }

  return isCommerceCheckoutPath(resolvedPath);
}
